"use strict";

exports.__esModule = true;
exports.default = createNumberConversion;
/**
 * Create number conversion functions
 * @param {number} start    Start number
 * @param {number} end      End number
 * @param {number} containerSize Container size width or height in pixels
 * @param {number} [margin=0]  Optional margin a side
 * @return {Object} Returns an object with functions
 *                  - numberToScreen(number: number) : number
 *                  - screenToNumber(y: number): number
 */
function createNumberConversion(start, end, containerSize) {
  var margin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var scale = (containerSize - 2 * margin) / (end - start);

  return {
    /**
     * Calculate the position in pixels on screen for a given number number
     * @param {number} number   Number number
     * @returns {number} Returns the x position in pixels on screen
     */
    unitToScreen: function unitToScreen(number) {
      return (number - start) * scale + margin;
    },

    /**
     * Calculate the time corresponding to the given number number
     * @param {number} x  Position in pixels on screen
     * @returns {number} Returns (unrounded!) number number
     */
    screenToUnit: function screenToUnit(axis) {
      return (axis - margin) / scale + start;
    }
  };
}